import React from "react";
import { useEffect } from "react";
import { useState } from "react";
import { Route, Routes } from "react-router-dom";
import AdminRoutes from "./AdminRoutes";
import AdminRoutesPermission from "./AdminRoutesPermission";
import AuthRoutes from "./AuthRoutes";
import { getSecureItem } from "../Utils/secureStorage";

export default function Routings() {
  const [roleClientAdmin, setRoleAdmin] = useState("admin");

  useEffect(() => {
    const admin = getSecureItem("userData");
    setRoleAdmin(admin?.role);
  }, []);

  return (
    <React.Fragment>
      <Routes>
        <React.Fragment>
          {roleClientAdmin === "superadmin" ? (
            <Route path="/admin/*" element={<AdminRoutes />} />
          ) : (
            <Route path="/admin/*" element={<AdminRoutesPermission />} />
          )}
          <Route path="/*" element={<AuthRoutes />} />
        </React.Fragment>
      </Routes>
    </React.Fragment>
  );
}
